import { QueryFunctionContext } from '@tanstack/react-query'
import { MsxService } from 'services/MsxService'
import { DEFAULT_QUANTITIES_QUERY_KEY } from 'shared/constants'

export const QUERY_KEY = DEFAULT_QUANTITIES_QUERY_KEY

export const queryDefaultQuantities = (
  context: QueryFunctionContext<VP.MTT.Queries.MsxService.DefaultQuantitiesQueryKey>,
): Promise<VP.MTT.Models.MsxService.DefaultQuantitiesResult | null> => {
  const { queryKey } = context
  const [_, { productKey, version, tenant, locales }] = queryKey

  return MsxService.getDefaultQuantities(tenant, locales, productKey, version)
}
